import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-[#1A1A1A] bg-[#030303] mt-32" data-testid="footer">
      <div className="grid grid-cols-12 gap-8 px-6 md:px-10 py-16">
        <div className="col-span-12 md:col-span-5">
          <div className="flex items-center gap-3">
            <img
              src="https://customer-assets-cm19k8pv.emergentagent.net/job_degoogled-oz/artifacts/c5gb5oy4_masked-hooded-ninja-assassin-warrior-emblem-vector-51649204%20%281%29.webp"
              alt="Phantom Phone"
              className="h-8 w-auto"
              style={{ filter: "invert(1)" }}
            />
            <span className="font-phantom text-[18px] tracking-[0.06em] uppercase">Phantom Phone</span>
          </div>
          <p className="mt-8 text-[#888] max-w-md text-sm leading-relaxed">
            Hand-hardened Google Pixel devices running GrapheneOS. Australian owned, Australian built, delivered
            with zero telemetry and full paranoia.
          </p>
        </div>
        <div className="col-span-6 md:col-span-2">
          <div className="overline mb-6">Shop</div>
          <ul className="space-y-3 text-[#EAEAEA] text-sm">
            <li><Link to="/shop?tier=degoogled">Degoogled</Link></li>
            <li><Link to="/shop?tier=secure">Secure</Link></li>
            <li><Link to="/shop?tier=phantom">Phantom</Link></li>
            <li><Link to="/hardening">Phantom Hardening</Link></li>
          </ul>
        </div>
        <div className="col-span-6 md:col-span-2">
          <div className="overline mb-6">Company</div>
          <ul className="space-y-3 text-[#EAEAEA] text-sm">
            <li><Link to="/manifesto">Manifesto</Link></li>
            <li><Link to="/compare">Compare tiers</Link></li>
            <li><Link to="/orders">Track order</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/admin">Admin</Link></li>
          </ul>
        </div>
        <div className="col-span-12 md:col-span-3">
          <div className="overline mb-6">Transmission</div>
          <p className="text-[#888] text-sm">Sydney · NSW · Australia</p>
          <p className="text-[#EAEAEA] text-sm mt-3">orders@phantomphone.local</p>
        </div>
      </div>
      <div className="border-t border-[#1A1A1A] px-6 md:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between text-[#444] text-xs">
        <div>© {new Date().getFullYear()} PHANTOM PHONE PTY LTD. ABN 00 000 000 000.</div>
        <div className="mt-4 md:mt-0 tracking-[0.24em] uppercase">Zero Knowledge · Zero Trust · Zero Compromise</div>
      </div>
    </footer>
  );
}
